import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Popover,
  PopoverArrow,
  PopoverCloseButton,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import { ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { findTalent } from 'services/api';
import { postActions, recruiterActions } from 'redux/actions';
import ReactPaginate from 'react-paginate';
// Update this import statement based on your project structure

import filterIcon from 'Assets/filterSearch.svg';
import style from 'pages/Student/Job/index.module.css';
import { UserCard } from 'Components/UserCard/UserCard';
import { NavbarCommon } from 'Components/Recruiter/Navbar/NavbarCommon';
import Navbar from 'Components/Recruiter/Navbar/Navbar';
import PortFolioFilter from 'Components/Students/FilterComp/PortFolioFilter';
import { SearchChip } from 'Components/SearchChip/SearchChip';

export const LandingPageSearch = () => {
  const [talents, setTalents] = useState([]);
  const dispatch = useDispatch();
  const [playAnimation, setPlayAnimation] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchParams, setSearchParams] = useSearchParams();
  console.log('search', searchParams.get('page'));
  const navigate = useNavigate();

  const companyId = useSelector((state) => state?.auth?.user?.companyId);
  useEffect(() => {
    dispatch(postActions.getPosts(companyId, 'active', setPlayAnimation));
  }, []);

  let talentsData = useSelector((state) => state?.recruiter?.talents);
  const users = JSON.parse(JSON.stringify(talentsData));
  const scrollPosition = useRef(0);
  const location = useLocation();

  const [searchTags, setSearchTags] = useState({
    text: '',
    tools: '',
    badges: '',
    level: '',
    location: '',
  });

  const [toggle, setToggle] = useState(false);
  const containerRef = useRef(null);
  // const history = useHistory();

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(recruiterActions.clearTalent());
        const { data } = await findTalent(`?search&page=${currentPage - 1}`);
        console.log(data, 'data');
        dispatch(recruiterActions.setTalents(data.data));
      } catch (e) {
        console.log(e);
      }
    };
    if (searchParams) {
      navigate(`/hiring/recruiter/findtalent?page=${currentPage}`);
    }
    fetchData();
    window.scrollTo(0, 0);
  }, [currentPage]);

  const searchMobile = async (text) => {
    findTalent(`?search=${text}`)
      .then((res) => {
        dispatch(recruiterActions.setTalents(res.data.data));
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const totalPages = useMemo(
    () => Math.ceil(talentsData && talentsData[0]?.total / 12),
    [talentsData]
  );

  console.log('current', currentPage, 'total', totalPages);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => Math.min(prevPage + 1, totalPages));
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => Math.max(prevPage - 1, 1));
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  useEffect(() => {
    navigate(`/hiring/recruiter/findtalent?page=1`);
  }, []);

  useEffect(() => {
    const currentPageParam = searchParams.get('page');
    if (currentPageParam) {
      setCurrentPage(Number(currentPageParam));
    }
  }, []);

  useEffect(() => {
    return () => {
      scrollPosition.current = window.pageYOffset;
    };
  }, []);
  useEffect(() => {
    window.scrollTo(0, scrollPosition.current);
  }, [location]);

  return (
    <>
      <NavbarCommon />
      <Navbar />
      <Flex position={'relative'} className='mobile-d-none'>
        <Image
          marginTop={'80px'}
          src='https://temp.ajnavidya.com/ajnavidya/bgimage-1681216693642.png'
          height={312}
        />
        <Text
          fontSize='50px'
          fontWeight='400'
          color='black'
          position={'absolute'}
          left={'50%'}
          top={'50%'}
          transform={'translate(-50%, -50%)'}
        >
          Hire{' '}
          <span
            style={{
              fontWeight: 'bolder',
            }}
          >
            Best
          </span>{' '}
          in industry talent
        </Text>
        <Text
          fontSize='22px'
          fontWeight='500'
          color='#7B7E83'
          position={'absolute'}
          left={'50%'}
          top={'63%'}
          transform={'translate(-50%, -50%)'}
        >
          Find the perfect Talent for your next project
        </Text>
      </Flex>
      <Box
        className='display-none'
        style={{
          marginTop: '80px',
          marginBottom: '20px',
        }}
      >
        <>
          <Heading
            className='display-none'
            size={'lg'}
            textAlign={'left'}
            mx={'12px'}
            marginBottom={'10px'}
          >
            Find Talent
          </Heading>
          <Popover
            zIndex={-1}
            isOpen={toggle}
            onClose={() => setToggle(false)}
            className='display-none'
          >
            <PopoverTrigger>
              <div
                className={style.filterIcon + ' ' + 'display-none'}
                style={{
                  padding: '0 10px',
                }}
              >
                <div className={style.compsearch}>
                  <input
                    onKeyDown={(e) =>
                      e.key === 'Enter' && searchMobile(e.target.value)
                    }
                    type='text'
                    placeholder='Search by job role, company name, skills'
                    autoComplete='off'
                  />
                </div>
                <Flex
                  mx={2}
                  w={'100%'}
                  justifyContent={'end'}
                  onClick={() => setToggle(!toggle)}
                >
                  <img src={filterIcon} alt='filter' />
                  <p className={style.filterTitle}>Add Filter</p>
                </Flex>
              </div>
            </PopoverTrigger>
            <PopoverContent
              boxShadow={'0px 8px 24px rgba(93, 93, 93, 0.15)'}
              css={{
                '@media screen and (min-width: 1280px) and (max-width:1540px)':
                  {
                    width: '350px',
                  },
                '@media screen and (min-width: 1541px) and (max-width:1980px)':
                  {
                    width: '450px',
                  },
              }}
            >
              <PopoverArrow />
              <PopoverCloseButton />
              <PortFolioFilter setSearchTags={setSearchTags} />
            </PopoverContent>
          </Popover>
        </>
      </Box>
      <Flex w='100%' padding={'0 1.8%'}>
        <Flex
          w={'25%'}
          h={'100vh'}
          margin={'0 2%'}
          position={'sticky'}
          top={'70px'}
          className='mobile-d-none'
        >
          <PortFolioFilter setSearchTags={setSearchTags} />
        </Flex>

        {/* filter */}
        <Flex w={'75%'} className='mobile-width-100' flexDirection={'column'}>
          <Flex my={2}>
            {Object.values(searchTags).map((key) => (
              <SearchChip
                name={key}
                clearSearch={setSearchTags}
                searchTag={searchTags}
              />
            ))}
          </Flex>
          <Flex flexFlow={'row wrap'}>
            {users?.map((item, index) => (
              <Flex
                key={index}
                mr={2}
                w={'32.33%'}
                marginBottom={10}
                className='mobile-width-100'
              >
                <UserCard
                  user={index + 1}
                  data={item}
                  number={
                    index % 5 === 0
                      ? 1
                      : index % 5 === 1
                      ? 2
                      : index % 5 === 2
                      ? 3
                      : index % 5 === 3
                      ? 4
                      : 5
                  }
                />
              </Flex>
            ))}
          </Flex>
          {/* if user length>26 */}

          {users?.length === 0 && (
            <Flex
              justifyContent={'center'}
              alignItems={'center'}
              w={'100%'}
              mt={200}
              disabled={currentPage === totalPages - 1}
            >
              <Text>No Data found </Text>
            </Flex>
          )}
        </Flex>
      </Flex>

      <Box
        display={'flex'}
        justifyContent={'center'}
        alignItems={'center'}
        mb={15}
        ml={400}
        ref={containerRef}
      >
        <Flex mt={5}>
          {/* Page numbers */}

          <ReactPaginate
            breakLabel='...'
            selectedPageRel='active'
            breakClassName='break-me'
            pageClassName='page-item'
            pageLinkClassName='page-link'
            previousClassName='page-item'
            previousLinkClassName='page-link'
            nextClassName='page-item'
            nextLinkClassName='page-link'
            containerClassName='pagination-1'
            activeClassName='active'
            breakLinkClassName='page-link'
            initialPage={currentPage - 1}
            forcePage={currentPage - 1}
            nextLabel={
              totalPages > 0 && currentPage < totalPages ? (
                <Button>
                  <ArrowForwardIcon />
                </Button>
              ) : null
            }
            onPageChange={(page) => handlePageChange(page.selected + 1)}
            pageRangeDisplayed={5}
            pageCount={totalPages}
            previousLabel={
              currentPage > 1 ? (
                <Button>
                  <ArrowBackIcon />
                </Button>
              ) : null
            }
          />
        </Flex>
      </Box>
    </>
  );
};
